import { OutboundFax } from "./outboundFax";

export class OutboundFaxData {
    faxes!: OutboundFax[];
    rowCount!: number;
    uniqueValues!: string;
    failedCount!: number;
  }